var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8865 26.7925V34.3276L35.6229 37.6806L28.8865 26.7925ZM43.8625 23.9735L35.8579 19.9976C35.7278 19.9285 35.5623 19.9797 35.484 20.1016L30.857 27.5815L36.3632 36.4785L43.9396 24.2411C44.0015 24.1456 43.9573 24.025 43.8625 23.9735ZM36.7585 38.2359L43.3497 41.5099C43.7311 41.7008 44.0444 41.5096 44.0444 41.0774V26.4685L36.7585 38.2359ZM27.6234 23.7347V41.0862C27.6234 41.5096 27.1004 41.9095 26.7177 41.7186L18.7812 37.554V20.3955C18.7812 20.1091 19.0705 19.7839 19.5833 20.0402L27.6234 23.7347Z",
    fill: "#1D4ED8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIcon);
export default __webpack_public_path__ + "static/media/content_icon.a1d6ab116ee07c9e927158c696a28c49.svg";
export { ForwardRef as ReactComponent };